import React, {
  useEffect,
  useState,
} from 'react';
import ClaimInfo from 'pages/Dashboard/pages/Billing/Charges/ClaimInfo';
import Section from 'pages/Dashboard/pages/Appointments/pages/List/components/Details/Section';
import OutOfPocketRow from 'pages/Dashboard/pages/Billing/Charges/OutOfPocketRow';
import {
  formatDateTime,
} from 'utils/date';
import Row from 'pages/Dashboard/components/Row';
import EOBInfo from 'pages/Dashboard/pages/Billing/Charges/EOBInfo';
import {
  useGetSummaryForEncounterId,
  useGetEOBSummariesByEncounterId,
} from 'pages/Dashboard/pages/Billing/hooks';
import {
  paymentsEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import {
  ChargesTabProps,
} from 'pages/Dashboard/pages/Billing/Charges/chargesPanelInfo';

export default function ChargeInfo({
  entity,
  selectedClaimId,
  onSelectedClaimChange,
}: ChargesTabProps) {
  // TODO: read visit date from the encounter summary once the API returns it, then drop the visitDate URL param
  const { encounterId, visitDate } = entity;

  const {
    data: chargeOverview,
    isLoading: isLoadingChargeOverview,
    refetch: refetchChargeOverview,
  } = useGetSummaryForEncounterId(encounterId);

  const {
    data,
    refetch: refetchEOBs,
    isLoading: isLoadingEOBs,
  } = useGetEOBSummariesByEncounterId(encounterId);

  const eobSummaries = data?.eoBs ?? [];
  // Held in state, so ClaimInfo renders its footer once the element is mounted
  const [footerElement, setFooterElement] = useState<HTMLDivElement | null>(null);

  const {
    appointment,
    claims = [],
  } = chargeOverview ?? {};

  const isOutOfPocket = appointment?.isOutOfPocket ?? false;

  useEffect(() => {
    const unsubscribeFromPaymentsChange = paymentsEventChannel.on('onPaymentsDataChanged', () => {
      refetchEOBs?.();
    });

    return () => {
      unsubscribeFromPaymentsChange();
    };
  }, []);

  return (
    <>
      <div className="flex flex-col gap-2 p-4 flex-1 overflow-auto">
        <Section title="Appointment">
          <Row title="Visited at">
            {formatDateTime(visitDate)}
          </Row>
          <OutOfPocketRow
            {...appointment}
            isOutOfPocket={isOutOfPocket}
          />
        </Section>
        <Section
          title={claims?.length === 0 && !isOutOfPocket && !isLoadingChargeOverview ? 'Claim is not created' : 'Claims'}
        >
          <ClaimInfo
            entity={entity}
            selectedClaimId={selectedClaimId}
            onSelectedClaimChange={onSelectedClaimChange}
            claims={claims ?? []}
            isLoading={isLoadingChargeOverview}
            isOutOfPocket={isOutOfPocket}
            footerElement={footerElement}
            onClaimChange={async (type) => {
              await refetchChargeOverview?.();
              if (type === 'delete') {
                await refetchEOBs?.();
              }
            }}
          />
        </Section>
        {!isLoadingEOBs && eobSummaries.length > 0 && (
          <Section title="EOBs">
            <EOBInfo
              entity={entity}
              eobSummaries={eobSummaries ?? []}
            />
          </Section>
        )}
      </div>
      <div ref={setFooterElement} />
    </>
  );
}
